import React from "react";

import FleetConfiguration from "app/modules/FleetConfiguration";

const VlvViewFleetConfiguration = () => {
    return <FleetConfiguration />;
};

export default VlvViewFleetConfiguration;
